import { createBrowserHistory } from 'history';
const publicURL=process.env.PUBLIC_URL;
export const history = createBrowserHistory({basename:publicURL});

